import { render, staticRenderFns } from "./DataAnalysisDashboardListPage.vue?vue&type=template&id=e044cc44"
import script from "./DataAnalysisDashboardListPage.vue?vue&type=script&lang=js"
export * from "./DataAnalysisDashboardListPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports